import React from "react";
import { Box, Chip, Paper, TextField, Typography } from "@mui/material";

interface Props {
  serviceBusString: string;
  selectedConnectionName: string | null;
  onChange: (value: string) => void;
  onClear: () => void;
}

export const ConnectionPanel: React.FC<Props> = ({
  serviceBusString,
  selectedConnectionName,
  onChange,
  onClear,
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      mb: 3,
      backgroundColor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
    }}
  >
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
      Service Bus Connection
    </Typography>
    {selectedConnectionName && (
      <Box sx={{ mb: 1 }}>
        <Chip
          label={`Using: ${selectedConnectionName}`}
          color="primary"
          onDelete={onClear}
          size="small"
        />
      </Box>
    )}
    <TextField
      fullWidth
      placeholder="Enter your Service Bus connection string"
      variant="outlined"
      value={serviceBusString}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      disabled={!!selectedConnectionName}
      helperText={
        selectedConnectionName
          ? "Connection resolved server-side from Key Vault. Clear the chip to paste a string."
          : undefined
      }
    />
  </Paper>
);
